import { BarChart, barElementClasses } from '@mui/x-charts/BarChart';
import { axisClasses } from '@mui/x-charts/ChartsAxis';
import { chartsGridClasses } from '@mui/x-charts/ChartsGrid';
import React from 'react';


function CostBreakdownChart({ details, marginLeft }) {
    const layout = 'horizontal'
    return (
        <div>
            <BarChart
                layout="horizontal"
                xAxis={[{
                    tickFontSize: 14,
                    tickLabelStyle: {
                        fontFamily: 'Inter',
                        fontWeight: '600',
                        fill: '#96948F',

                    },
                    tickSize: 20,
                    tickLabelInterval: (value, index) => {
                        if (value % 10 == 0) return true
                    },
                    disableTicks: true,
                    disableLine: true
                }]}
                yAxis={[{
                    tickFontSize: 14,
                    tickLabelStyle: {
                        fontFamily: 'Inter',
                        fontWeight: '600',
                        fill: '#96948F',

                    },
                    tickSize: 20,
                    scaleType: 'band',
                    dataKey: 'order',
                    data: details?.map(day => day.label),
                    disableTicks: true,
                    categoryGapRatio: .4,
                    barGapRatio: .6,
                    disableLine: true
                }]}
                dataset={details?.map(day => day.data)}
                series={[
                    { dataKey: 'breakfast', label: 'Breakfast', layout, stack: 'stack', color: 'url(#moneyGradient)' },
                    { dataKey: 'lunch', label: 'Lunch', layout, stack: 'stack', color: 'url(#moneyGradient)' },
                    { dataKey: 'dinner', label: 'Dinner', layout, stack: 'stack', color: 'url(#moneyGradient)' },
                    { dataKey: 'other', label: 'Other', layout, stack: 'stack', color: `url(#moneyGradient)` }
                ]}
                margin={{ left: marginLeft, right: 30, top: 20, bottom: 40 }}
                borderRadius={9}
                height={400}
                slotProps={{ legend: { hidden: true } }}
            >
                <defs>
                    <linearGradient id="moneyGradient" x1="0" x2="0" y1="0" y2="1">
                        <stop offset="0%" stopColor="#82BD9C" />
                        <stop offset="100%" stopColor="#bac39d" />
                    </linearGradient>
                </defs>
            </BarChart>
        </div >
    );
}


export default CostBreakdownChart;